/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { BsFillPlusCircleFill } from 'react-icons/bs';
import Switch from 'react-switch';
import ManajemenSoalCreateController, {
  useManajemenSoalCreateContext,
} from '../../../../controller/admin/manajemen_soal/create';
import ManajemenSoalDetailController, {
  useManajemenSoalDetailContext,
} from '../../../../controller/admin/manajemen_soal/detail';
import { ToastContainer } from 'react-toastify';
import ReactLoading from 'react-loading';
import { If, Then, Else } from 'react-if';
import { Editor } from '@tinymce/tinymce-react';
import AWS from 'aws-sdk';
import update from 'immutability-helper';
import SidebarWithHeader from '../../../../components/Admin/SidebarWithHeader';
import env from '@ludovicm67/react-dotenv';
import EditorComponent from '../../../../components/Admin/Editor';

const BottomHeader: React.FC = () => {
  const { savePertanyaan } = useManajemenSoalCreateContext();
  const { isLoadingCreateSoal } = useManajemenSoalCreateContext().state;
  const { paketSoal } = useManajemenSoalDetailContext().state;

  return (
    <div className="w-full bg-white flex flex-wrap justify-between">
      <div className="px-6 py-3 items-center">
        <a>Tambah Soal {paketSoal?.jenis_soal}</a>
      </div>

      <div className="px-6 py-2 flex relative">
        <button
          type="button"
          className="px-6 py-2 bg-yellow-500 text-white font-semibold text-xs leading-tight rounded shadow-md hover:bg-yellow-700 "
          disabled={isLoadingCreateSoal}
          onClick={() => {
            savePertanyaan(window.location.pathname.split('/', 5)[4], 'simpan');
          }}
        >
          <If condition={isLoadingCreateSoal}>
            <Then>
              <ReactLoading
                type={'bars'}
                color={'white'}
                height={15}
                width={20}
              />
            </Then>
            <Else>Simpan</Else>
          </If>
        </button>
        <button
          type="button"
          className="ml-2 flex px-6 py-2 bg-green-600 text-white font-semibold text-xs leading-tight rounded shadow-md hover:bg-green-700 "
          disabled={isLoadingCreateSoal}
          onClick={() => {
            savePertanyaan(window.location.pathname.split('/', 5)[4], 'tambah');
          }}
        >
          <If condition={isLoadingCreateSoal}>
            <Then>
              <ReactLoading
                type={'bars'}
                color={'white'}
                height={15}
                width={20}
              />
            </Then>
            <Else>Simpan & Tambah Baru</Else>
          </If>
          <BsFillPlusCircleFill className="ml-2" style={{ marginTop: '2px' }} />
        </button>
      </div>
    </div>
  );
};

const ItemOpsi = ({ opsi }: { opsi: Array<string> }): JSX.Element => {
  const [jawaban, setJawaban] = useState('');
  const [jawabanMulti, setJawabanMulti] = useState([{ jawaban_benar: '' }]);
  const { setPilihan, deleteJawaban, setJawabanBenar } =
    useManajemenSoalCreateContext();
  const { jawabanData, pilihanJawaban } = useManajemenSoalCreateContext().state;
  const { paketSoal } = useManajemenSoalDetailContext().state;

  console.log('pilihanJawaban', pilihanJawaban);

  const deleteJawabanUser = (idx) => {
    deleteJawaban(idx);
  };

  const onChangeJawabanBenar = (val) => {
    if (paketSoal?.jenis_soal == 'Pilihan Ganda Kompleks') {
      const findData = jawabanMulti.findIndex((v) => v.jawaban_benar == val);

      if (findData != -1) {
        const newData = update(jawabanMulti, {
          $splice: [[findData, 1]],
        });

        setJawabanMulti(newData);
      } else {
        setJawabanMulti((prevState) => [...prevState, { jawaban_benar: val }]);
      }
    } else {
      setJawaban(val);
    }
  };

  const checkTrueFalseMulti = (val) => {
    const checkValue = jawabanMulti.find((v) => v.jawaban_benar == val);

    if (checkValue) {
      return true;
    } else {
      return false;
    }
  };

  var data: JSX.Element[] = [];
  opsi.map((pg, idx) =>
    data.push(
      <div className="mt-10" key={idx}>
        <div className="flex justify-between mb-2">
          <div className="flex flex-row">
            {paketSoal?.jenis_soal == 'Pilihan Ganda Kompleks' ? (
              <>
                <p>Jawaban {checkTrueFalseMulti(pg) ? 'Benar' : 'Salah'}</p>
                <Switch
                  className="ml-2"
                  height={20}
                  onChange={() => {
                    onChangeJawabanBenar(pg);
                    setJawabanBenar(idx, paketSoal?.jenis_soal);
                  }}
                  checked={checkTrueFalseMulti(pg) ? true : false}
                />
              </>
            ) : (
              <>
                <p>Jawaban {jawaban == pg ? 'Benar' : 'Salah'}</p>
                <Switch
                  className="ml-2"
                  height={20}
                  onChange={() => {
                    onChangeJawabanBenar(pg);
                    setJawabanBenar(idx, paketSoal?.jenis_soal);
                  }}
                  checked={jawaban == pg ? true : false}
                />
              </>
            )}
          </div>
          <div className="flex flex-row">
            <button
              onClick={() => deleteJawabanUser(idx)}
              type="button"
              className="px-3 py-2 bg-red-500 text-white font-semibold text-md leading-tight rounded shadow-md hover:bg-red-700"
            >
              <i className="fas fa-trash"></i>
            </button>
          </div>
        </div>
        <EditorComponent
          description={`${pilihanJawaban[idx]?.value ?? ''}`}
          setDescription={(a: any) => setPilihan(a, pg)}
          withKey={false}
        />
      </div>
    )
  );
  return (
    <>
      {data.map((data) => (
        <div>{data}</div>
      ))}
    </>
  );
};

const WrapperMain: React.FC = () => {
  const { setSoal, setIncrement } = useManajemenSoalCreateContext();
  const { increment, opsiJawaban, soal } =
    useManajemenSoalCreateContext().state;
  const { getDetailPaketSoal } = useManajemenSoalDetailContext();

  const tambahJawaban = () => {
    setIncrement(increment);
  };

  React.useEffect(() => {
    getDetailPaketSoal(window.location.pathname.split('/', 5)[4]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="app">
      <main style={{ padding: '0px' }}>
        <header className="sticky top-0 z-40">
          <BottomHeader />
        </header>
        <div className="container px-8">
          {/* Pertanyaan */}
          <div className="bg-white rounded-md px-5 py-5">
            <div className="form-group mb-6">
              <label className="form-label inline-block mb-2 text-gray-700">
                Pertanyaan
              </label>
              <div className="w-full">
                <EditorComponent
                  description={soal as string}
                  setDescription={(val: any) => setSoal(val)}
                  withKey={false}
                />
              </div>
            </div>
          </div>

          {/* Jawaban */}
          <div className="bg-white rounded-md px-5 py-5 mt-3 mb-5">
            <If condition={opsiJawaban.length > 0}>
              <ItemOpsi opsi={opsiJawaban} />
            </If>
            <div className="text-center py-10">
              <button
                type="button"
                className="px-6 py-2 bg-yellow-500 text-white font-semibold text-xs leading-tight rounded shadow-md hover:bg-yellow-700 align-left mb-5"
                onClick={tambahJawaban}
              >
                Tambah Field Jawaban
              </button>
              <p className="text-2xl">
                Silahkan klik tombol diatas untuk menambahkan field jawaban.
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

const FormManajemenSoal: React.FC = () => {
  return (
    <ManajemenSoalCreateController.Provider>
      <ManajemenSoalDetailController.Provider>
        <ToastContainer
          position="top-center"
          style={{ width: '60%', marginTop: '5%' }}
        />
        <SidebarWithHeader title="Manajemen Soal">
          <WrapperMain />
        </SidebarWithHeader>
      </ManajemenSoalDetailController.Provider>
    </ManajemenSoalCreateController.Provider>
  );
};

export default FormManajemenSoal;
